import { c as _c } from "react/compiler-runtime";
import { Divider } from '@onefootprint/ui';
import { cx } from 'class-variance-authority';
import { format } from 'date-fns';
import capitalize from 'lodash/capitalize';
import { useTranslation } from 'react-i18next';
type SummaryBoxProps = {
  recommendation: string; // TODO: BE will make this field a specific type
  reasoningSummary: string;
};
const SummaryBox = t0 => {
  const $ = _c(33);
  const {
    recommendation,
    reasoningSummary
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "agentExecutionSummary.summaryBox"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = format(new Date(), "MMMM d, yyyy");
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const currentDate = t2;
  let t3;
  if ($[2] !== t) {
    t3 = t(_temp);
    $[2] = t;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t3) {
    t4 = <span className="text-label-2 text-primary">{t3}</span>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <span className="text-body-2 text-secondary">{currentDate}</span>;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t4) {
    t6 = <div className="flex gap-1 items-center">{t4}{t5}</div>;
    $[7] = t4;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Divider className="border-tertiary" />;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t) {
    t8 = t(_temp2);
    $[10] = t;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t8) {
    t9 = <span className="text-label-2 text-primary">{t8}</span>;
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  const t10 = recommendation === "clear";
  const t11 = recommendation === "escalate";
  let t12;
  if ($[14] !== t10 || $[15] !== t11) {
    t12 = cx("text-body-2", {
      "text-success": t10,
      "text-error": t11
    });
    $[14] = t10;
    $[15] = t11;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  let t13;
  if ($[17] !== recommendation) {
    t13 = capitalize(recommendation);
    $[17] = recommendation;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  let t14;
  if ($[19] !== t12 || $[20] !== t13) {
    t14 = <span className={t12}>{t13}</span>;
    $[19] = t12;
    $[20] = t13;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  let t15;
  if ($[22] !== t14 || $[23] !== t9) {
    t15 = <div className="flex gap-1 items-center">{t9}{t14}</div>;
    $[22] = t14;
    $[23] = t9;
    $[24] = t15;
  } else {
    t15 = $[24];
  }
  let t16;
  if ($[25] !== reasoningSummary) {
    t16 = <span className="text-body-2 text-secondary">{reasoningSummary}</span>;
    $[25] = reasoningSummary;
    $[26] = t16;
  } else {
    t16 = $[26];
  }
  let t17;
  if ($[27] !== t15 || $[28] !== t16) {
    t17 = <div className="flex flex-col gap-1">{t15}{t16}</div>;
    $[27] = t15;
    $[28] = t16;
    $[29] = t17;
  } else {
    t17 = $[29];
  }
  let t18;
  if ($[30] !== t17 || $[31] !== t6) {
    t18 = <div className="bg-secondary rounded-md p-3 flex flex-col gap-2">{t6}{t7}{t17}</div>;
    $[30] = t17;
    $[31] = t6;
    $[32] = t18;
  } else {
    t18 = $[32];
  }
  return t18;
};
export default SummaryBox;
function _temp($) {
  return $.date;
}
function _temp2($_0) {
  return $_0.recommendation;
}